import { FunctionalComponent, h } from '@stencil/core'

import imageSrc from './ai_loader.gif'

export const AskFathomLoading: FunctionalComponent<{ className?: string }> = ({ className = '' }) => (
  <img class={className} style={{ width: '26px' }} src={imageSrc} />
)
